import "../../../assets/RideSpinner.css";
import s from "react";
import a from "clsx";
const l = "_rotate_1wus9_1", o = "_small_1wus9_65", c = "_medium_1wus9_69", d = "_large_1wus9_73", u = "_inverse_1wus9_77", m = "_loading_1wus9_1", e = {
  "ride-spinner": "_ride-spinner_1wus9_54",
  "svg-container": "_svg-container_1wus9_57",
  rotate: l,
  "svg-spinner": "_svg-spinner_1wus9_62",
  small: o,
  medium: c,
  large: d,
  inverse: u,
  "fade-in": "_fade-in_1wus9_1",
  "fade-out": "_fade-out_1wus9_1",
  loading: m,
  "slide-in-up": "_slide-in-up_1wus9_1",
  "slide-in-down": "_slide-in-down_1wus9_1",
  "fill-center-out": "_fill-center-out_1wus9_1"
};
function v({
  className: n,
  inverse: t,
  size: i = "small",
  "data-testid": r
}) {
  const _ = () => a(n, e["ride-spinner"], e[i], {
    [e.inverse]: t
  });
  return /* @__PURE__ */ s.createElement("div", { "data-testid": r, className: _() }, /* @__PURE__ */ s.createElement("div", { className: e["svg-container"] }, /* @__PURE__ */ s.createElement(
    "svg",
    {
      className: e["svg-spinner"],
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    },
    /* @__PURE__ */ s.createElement(
      "path",
      {
        d: `M1.7,8L1.7,8C0.7,8,0,7.1,0.2,6.2C1,2.6,4.2,0,8,0c3.3,0,6.2,2,7.4,5c0.4,0.9-0.2,1.9-1.2,2l0,0\r
    c-0.7,0.1-1.4-0.2-1.6-0.9C11.9,4.3,10.1,3,8,3C5.6,3,3.6,4.7,3.1,6.9C3,7.5,2.4,8,1.7,8z`
      }
    )
  )));
}
export {
  v as RideSpinner
};
